import React, { useEffect, useRef, useState } from 'react';
import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ModalBusyContainer from 'components/ModalBusyContainer';

const useStyles = makeStyles(() => ({
  actions: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    '& .MuiButtonBase-root': {
      minWidth: '140px',
    },
  },
}));

const ConfirmationModalBody = ({ message, confirmAction, rejectAction, confirmTitle, rejectTitle }) => {
  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleConfirm = async () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    try {
      await confirmAction();
    } finally {
      if (isMountedRef.current) {
        setIsSubmitting(false);
      }
    }
  };

  const handleReject = () => {
    if (isSubmitting) {
      return;
    }
    rejectAction();
  };

  return (
    <ModalBusyContainer busy={isSubmitting}>
      <p>{message}</p>
      <Box className={classes.actions}>
        <Button type="button" disabled={isSubmitting} onClick={handleConfirm} variant="contained" color="primary">
          {confirmTitle}
        </Button>
        <Button type="button" disabled={isSubmitting} onClick={handleReject} variant="outlined">
          {rejectTitle}
        </Button>
      </Box>
    </ModalBusyContainer>
  );
};

const getConfirmationModalConfig = ({
  title = '',
  confirmAction,
  rejectAction,
  closeAction,
  message,
  confirmTitle = 'Yes',
  rejectTitle = 'Cancel',
}) => [
  {
    key: 0,
    size: 'small',
    title,
    onClose: closeAction,
    // Buttons live in content so they share submitting/loading state with ModalBusyContainer.
    actions: [],
    modalType: 'notification',
  },
  <ConfirmationModalBody
    key={1}
    message={message}
    confirmAction={confirmAction}
    rejectAction={rejectAction}
    confirmTitle={confirmTitle}
    rejectTitle={rejectTitle}
  />,
];

export default getConfirmationModalConfig;
